"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { tv } from 'tailwind-variants';

function GenericSvgIcon({ type, ...props }) {
  return /* @__PURE__ */ jsx(SvgIcon, { type, ...props, "aria-hidden": "true" });
}
function GenericImgIcon({ src, ...props }) {
  return /* @__PURE__ */ jsx("img", { src, ...props, alt: "", "aria-hidden": "true" });
}
const itemIconRecipe = tv({
  slots: withSlotScopeClasses("item_icon", {
    icon: "flex shrink-0 grow-0 w-6 h-6 rounded-lg p-1"
  }),
  variants: {
    framed: {
      true: {
        icon: "bg-bg-muted border-bg-disabled border-[0.5px] text-fg-muted"
      }
    }
  },
  defaultVariants: {
    framed: false
  }
});
function ItemIcon({
  className,
  framed,
  ...props
}) {
  const { icon } = itemIconRecipe({ framed });
  if ("type" in props && props?.type) {
    return /* @__PURE__ */ jsx(GenericSvgIcon, { className: icon({ className }), ...props });
  }
  if ("src" in props && props?.src) {
    return /* @__PURE__ */ jsx(GenericImgIcon, { className: icon({ className }), ...props });
  }
  return null;
}

export { ItemIcon };
